import { render, staticRenderFns } from "./RelatorioCotasCliente.vue?vue&type=template&id=2fe957c6"
import script from "./RelatorioCotasCliente.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports